'use client';

import React from 'react';
import Image from 'next/image';

// import astro from '../../../public/hotels/pop_up5.png';
import { useTranslations } from 'next-intl';
import { cn } from '@/lib/utils';

interface AuthLayoutWrapProps {
  children: React.ReactNode;
  page: 'login' | 'register';
  showBanner?: boolean;
}

export default function VendorAuthLayout({
  children,
  page,
  showBanner = true,
}: AuthLayoutWrapProps) {
  const t = useTranslations('storefront');
  return (
    <main className="auth-layout-wrap relative flex h-[100dvh] min-h-screen w-full flex-col items-center justify-between pt-[60px] lg:pt-[70px] xl:pt-[90px]">
      <section className="mx-auto mb-[30px] flex h-full w-full items-center justify-center lg:mb-[50px] xl:mb-[70px] xl:w-[1020px] xl:items-stretch 2xl:w-[1240px]">
        {showBanner && (
          <div className="hidden rounded-s-xl bg-[linear-gradient(90deg,_#F5375C_0%,_#C33076_100%)] xl:block xl:w-1/2 xl:p-[50px] 2xl:p-[70px]">
            <div className="flex h-full flex-col items-center justify-center">
              <Image
                // src="/burger.png"
                // width={540}
                // height={826}
                src={'/hotels/pop_up5.png'}
                width={250}
                height={400}
                alt="astro with coin image"
                sizes="100vw"
                priority
              />

              {page === 'login' && (
                <>
                  <p className="mt-[10px] text-h5 text-white">
                    {t('restaurant_login.banner_subtitle')}
                  </p>
                  <p className="mt-[5px] max-w-[350px] break-normal text-center text-h4 font-black text-white lg:text-h3">
                    {t('restaurant_login.banner_title')}
                  </p>
                </>
              )}
              {page === 'register' && (
                <>
                  <p className="mt-[10px] text-h5 text-white">
                    {t('restaurant_registration.banner_subtitle')}
                  </p>
                  <p className="mt-[5px] max-w-[350px] break-normal text-center text-h4 font-black text-white lg:text-h3">
                    {t('restaurant_registration.banner_title')}
                  </p>
                </>
              )}
            </div>
          </div>
        )}
        <div
          className={cn(
            'w-full overflow-hidden xl:shadow-card',
            showBanner ? 'rounded-e-xl xl:w-1/2' : 'rounded-xl'
          )}
        >
          <div className="h-full items-center justify-center md:rounded-e-xl lg:flex xl:bg-white">
            {children}
          </div>
        </div>
      </section>
      {/* <footer className="mx-auto w-full sm:max-w-[400px] xl:max-w-[456px]">
        <Image
          src="/tomato-leafs.png"
          width={608}
          height={261}
          alt="footer-img"
          sizes="100vw"
          className="h-auto w-full"
        />
      </footer> */}
    </main>
  );
}
